
export const apiKey = "AIzaSyBPOKA8LYkfRKR_E1i7mw8kzuxKKILSlIw";
export const authDomain = "newtopia-a4327.firebaseapp.com";
export const projectId = "newtopia-a4327";
export const storageBucket = "newtopia-a4327.appspot.com";
export const messagingSenderId = "383729753701";
export const appId = "1:383729753701:web:0b75cbce6fe56a118e308c";
export const measurementId = "G-M1QSYCDRKT";